// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__1IqFv","ActionBox":"styles_ActionBox__o51rZ"};